// This page does nothing without this file loaded so no need for lazy loading

import Vue from 'vue';
import VueMask from 'v-mask';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);
Vue.use(VueMask, {
    placeholders: {
        'V': /[fnFN]/
    }
});

const vm = new Vue({
    name: 'Subscription form',
    el: '#subscribeForm',
    data: () => ({
        errors: [],
        hideForm: true,
        error: false,
        success: false,
        loading: false,
        firstname: '',
        lastname: '',
        riziv: '',
        type: '',
        email: '',
        language: '',
        organization: '',
        rizivApi: 'api/webinars/get-user-info-riziv',
        api: 'api/webinars/subscribe',
        csrf: window.csrfTokenValue,
        csrfName: window.csrfTokenName,
        active: true,
        otherType: window.otherType,
        errorMsg: '',
        invalid: false,
        masks: {
            default: '#-#####-##-###',
            28: 'V-####',
        },
        placeholders: {
            default: '1-12345-12-123',
            "28-nl": 'N-1234',
            "28-fr": 'F-1234',
        }
    }),
    methods: {
        send() {
            let data = {
                firstname: this.firstname,
                lastname: this.lastname,
                riziv: this.riziv,
                type: this.type,
                email: this.email,
                language: this.language,
                organization: this.organization
            }
            data[this.csrfName] = this.csrf;

            this.axios.post(this.api, data).then((response) => {
                console.log(response.data);
                if (response.data.invalidWebinars.length > 0) {
                    this.invalid = true
                    this.errorMsg = response.data.invalidWebinars[0]
                } else {
                    this.invalid = false
                    this.error = false;
                    this.active = false;
                    this.success = true;
                    document.querySelector("#sidebar").style.display = "none";
                    document.querySelector("#infoMsg2").style.display = "none";
                    document.querySelector("#successMsg").style.display = "inline-block";
                }
            }).catch(err => {
                console.log(err);
            })
        },
        checkRiziv() {
            this.axios.get(this.rizivApi, {
                params: {
                    riziv: this.riziv
                }
            }).then((response) => {
                if (response.data.user !== null) {
                    this.firstname = response.data.user.firstname;
                    this.lastname = response.data.user.lastname;
                    this.email = response.data.user.email;
                    this.language = response.data.user.language;
                    this.organization = response.data.user.function;

                }
                this.showForm();
            }).catch(err => {
                console.log(err)
            })
        },
        checkInput() {
            if (this.type === nurseType) {
                this.$refs.riziv.classList.remove('hidden');
                this.hideForm = true;
            } if (this.type === otherType) {
                this.showFormWithoutRiziv()
            } else {
                this.$refs.riziv.classList.remove('hidden');
                this.hideForm = true;
            }
        },
        showFormWithoutRiziv() {
            this.riziv = '';
            this.$refs.riziv.classList.add('hidden');
            this.showForm();
        },
        showForm() {
            document.querySelector("#infoMsg1").style.display = "none";
            document.querySelector("#infoMsg2").style.display = "inline-block";
            this.hideForm = false;
        },
        checkForm: function (e) {
            this.errors = [];
            this.$refs['type'].classList.remove('error');
            this.$refs['firstname'].classList.remove('error');
            this.$refs['lastname'].classList.remove('error');
            this.$refs['language'].classList.remove('error');
            this.$refs['email'].classList.remove('error');

            if (!this.type) {
                this.errors.push("Type required.");
                this.$refs['type'].classList.add('error');
                this.error = true;
            }
            if (!this.firstname) {
                this.errors.push("Name required.");
                this.$refs['firstname'].classList.add('error');
                this.error = true;
            }
            if (!this.lastname) {
                this.errors.push("Surname required.");
                this.$refs['lastname'].classList.add('error');
                this.error = true;
            }
            if (!this.language) {
                this.errors.push("Language required.");
                this.$refs['language'].classList.add('error');
                this.error = true;
            }
            if (!this.email) {
                this.errors.push('Email required.');
                this.$refs['email'].classList.add('error');
                this.error = true;
            } else if (!this.validEmail(this.email)) {
                this.errors.push('Valid email required.');
                this.$refs['email'].classList.add('error');
                this.error = true;
            }

            if (!this.errors.length) {
                this.send()
            }

            e.preventDefault();
        },
        validEmail: function (email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    },
    computed: {
        getMask() {
            if (this.type == 28) return this.masks["28"];
            return this.masks.default;
        },
        getPlaceholder() {
            if (this.type == 28) {
                const language = this.$el.dataset.language;
                return this.placeholders["28-" + language];
            }

            return this.placeholders.default;
        }
    },
    beforeMount() {
        document.querySelector("#infoMsg2").style.display = "none";
        document.querySelector("#successMsg").style.display = "none";
    }
});